// app/components/LoadingIndicator.tsx
'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import PreloaderComponent from './preloader';

export default function LoadingIndicator() {
    const pathname = usePathname();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        const timeout = setTimeout(() => {
            setLoading(false);
        }, 300); // Adjust duration based on your needs

        return () => clearTimeout(timeout);
    }, [pathname]); // Runs on route change

    // console.log('Loading state:', loading);
    

    if (!loading) return null;

    return (
        <PreloaderComponent />
    );
}
